import _ from 'lodash'

class Converter {
  static convertPageInfoFromV1(pageInfo) {
    const res = {
      pageId: pageInfo.pageId,
      pageTitle: pageInfo.pageTitle,
      containers: [],
      buttons: pageInfo.buttons
    }

    const { containers } = pageInfo
    res.containers = _.map(containers, container => {
      let type
      switch (container.type) {
        case '1':
          type = 2
          break
        case '2':
          type = 1
          break
        case '3':
          type = 3
          break
      }
      const res = {
        containerId: container.containerId,
        type
      }

      if (res.type === 2) {
        // 表单
        res.items = _.map(container.cols, item => {
          const newItem = {
            label: item.label,
            labelWidth: `${item.labelWidth}px`,
            value: item.value,
            compWidth: `${item.width}px`,
            editable: item.editable,
            tooltip: item.tooltip,
            options: item.options,
            suggestions: _.map(item.tips, tip => {
              return { value: tip }
            }),
            minLength: item.minLength,
            maxLength: item.maxLength,
            src: item.value,
            thumbnailWidth: item.thumbWidth ? `${item.thumbWidth}px` : null,
            thumbnailHeight: item.thumbHeight ? `${item.thumbHeight}px` : null,
            supportTypes: item.fileTypes,
            supportSize: item.limitSize,
            supportMinWidth: Number(item.minWidth),
            supportMaxWidth: Number(item.maxWidth),
            supportMinHeight: Number(item.minHeight),
            supportMaxHeight: Number(item.maxHeight),
            scaleWH: item.scaleWH,
            uploadAction: item.uploadAction,
            musicName: item.fileName,
            videoName: item.fileName,
            id: `${item.id}`,
            type: Converter._componentType(item.type),
            required: item.required,
            pageName: item.pageName,
            buttonText: item.controlText,
            expression: item.expression,
            alwaysEdit: item.alwaysEdit,
            defaultValue: item.defaultValue,
            types: item.type,
            color: item.color,
          }
          return newItem
        })
        res.columnNum = 1
      } else if (res.type === 1) {
        // 表格
        res.cols = _.map(container.cols, item => {
          const newItem = {
            colId: item.colId,
            label: item.label,
            width: item.width ? `${item.width}` : null,
            headerAlign: item.headerAlign,
            align: item.textAlign,
            isName: item.isName,
            editable: item.editable,
            required: item.required,
            component: {
              type: Converter._componentType(item.type),
              property: {
                compWidth: item.width ? `${item.width}px` : null,
                tooltip: item.tooltip,
                options: item.options,
                suggestions: _.map(item.tips, tip => {
                  return { value: tip }
                }),
                minLength: item.minLength,
                maxLength: item.maxLength,
                thumbnailWidth: item.thumbWidth ? `${item.thumbWidth}px` : null,
                thumbnailHeight: item.thumbHeight
                  ? `${item.thumbHeight}px`
                  : null,
                supportTypes: item.fileTypes,
                supportSize: item.limitSize,
                supportMinWidth: Number(item.minWidth),
                supportMaxWidth: Number(item.maxWidth),
                supportMinHeight: Number(item.minHeight),
                supportMaxHeight: Number(item.maxHeight),
                scaleWH: item.scaleWH,
                buttonText: item.controlText,
                pageName: item.pageName,
                expression: item.expression,
                defaultValue: item.defaultValue,
                types: item.type,
                color: item.color
              }
            }
          }

          return newItem
        })

        const size = container.cols.length
        res.rows = []
        if (size > 0) {
          _.forEach(container.cols[0].values, item => {
            res.rows.push({
              rowId: item.rowId,
              deletable: !item.cannotDelete
            })
          })

          _.forEach(container.cols, item => {
            const values = item.values
            _.forEach(values, (row, index) => {
              res.rows[index][item.colId] = {
                editable: row.editable,
                options: row.options,
                value: row.value,
                musicName: row.fileName,
                videoName: row.fileName,
                uploadAction: row.uploadAction,
                tag: row.tag
              }
            })
          })
        }

        res.tableButtons = container.tableButtons
      } else if (res.type === 3) {
        res.html = container.html
      }

      return res
    })
    return res
  }

  static _componentType(type) {
    switch (type) {
      case 'text':
        return 'jtInput'
      case 'email':
        return 'jtEmail'
      case 'phone':
        return 'jtPhone'
      case 'sdate':
        return 'jtDate'
      case 'stime':
        return 'jtTime'
      case 'sdateTime':
        return 'jtDatetime'
      case 'idcard':
        return 'jtIdCard'
      case 'idcardGlobal':
        return 'jtIdCard'
      case 'single':
        return 'jtSingleProject'
      case 'group':
        return 'jtGroupProject'
      case 'select':
        return 'jtSelect'
      case 'image':
        return 'jtImage'
      case 'music':
        return 'jtMusic'
      case 'musicMP3':
        return 'jtMusic'
      case 'video':
        return 'jtVideo'
      case 'html':
        return 'jtHtml'
      case 'district':
        return 'jtDistrict'
      case 'groupselect':
        return 'jtGroupSelect'
      case 'statusButton':
        return 'jtStatusButton'
      case 'redirectPage':
        return 'jtRedirectPage'
      case 'htmlEdit':
        return 'jtHtmlEdit'
      case 'limitsingle':
        return 'jtLimitSingle'
      case 'actions':
        return 'jtActions'
      case 'limitText':
        return 'jtLimitText'
      case 'imageUrl':
        return 'jtImage'
      case 'limitgroup':
        return 'jtLimitGroup'
      case 'idcardUnique':
        return 'jtIdCard'
      case 'idcardChnUnique':
        return 'jtIdCard'
      case 'taoluRequired':
        return 'jtTaoluRequired'
      case 'taoluDifficulty':
        return 'jtTaoluDifficulty'
      case 'selectOnce':
        return 'jtSingleSelect'
    }
  }
}

export default Converter
